import cn from 'classnames';
import dynamic from 'next/dynamic';
/* Constants */
import { GUARANTEE_TEXTS } from '@scenes/PlansPage/planspage.constants';
/* Components */
import { Grid } from 'ht-styleguide';
import Image from 'next/legacy/image';
import LazyComponent from '@components/LazyComponent';
import styles from './safetyAndSupportPage.module.scss';

/* Dynamic imports */
const PlanGuaranteeBlockDynamic = dynamic(() => import('@scenes/PlansPage/Parts/PlanGuaranteeBlock'), { ssr: false });

const SafetyAndSupportPage = () => (
  <>
    <div className={cn('paddingY-huge', styles.snsHero)}>
      <Grid.Fluid>
        <h1 className={cn(styles.headerText, 'h2 white textAlignCenter')}>HelloTech’s Commitment to Safety and Support</h1>
      </Grid.Fluid>
    </div>
    <Grid.Fluid classes="paddingTop-large">
      <div className={styles.bodyContainer}>
        <p className="p1 marginBottom-large">
          At HelloTech, our top priority is to provide you with exceptional service and support. That’s why we invest in knowledge development
          resources for our technicians as well as continual training of our customer support staff. We know how challenging it can be to keep up with
          the latest in technology. That’s why we aim to be your go-to experts, so you don’t have to!
        </p>

        <div className="marginBottom-large">
          <Image src="/_nextassets_/images/couple-with-device.png" height={640} width={1336} quality={50} alt="Users with device" />
        </div>

        <h2 className="h3 marginBottom-small">We appreciate you for putting your trust in us by inviting HelloTech into your home</h2>
        <p className="p1 marginBottom-small">
          We invest time and resources into ensuring your safety by taking numerous precautions to carefully and fully vet our technicians. Our
          rigorous background check process searches through national, state and county databases over the past 7 years to screen for any offense that
          would disqualify a potential technician from our service platform.{' '}
        </p>
        <p className="p1 marginBottom-large">
          For the safety of our techs on the job, HelloTech also makes occupational and accidental insurance available to protect technicians from any
          potential injuries that may occur while they’re in your home.
        </p>

        <LazyComponent minHeight="300px">
          <h2 className="h3 marginBottom-small">Our commitment to you</h2>
          <p className="p1 marginBottom-large">
            At HelloTech, we are dedicated to maintaining a premium level of service and support for all of our customers. This means investing in the
            latest tools, training, and products for our team. Whenever you need assistance, we’re here to help. HelloTech support agents are standing
            by to assist with booking, diagnosing issues and troubleshooting issues remotely when possible. We’re in the business of making technology
            simple, and we believe that providing a seamless customer experience is the best way to do so.
          </p>

          <div className="marginBottom-large">
            <Image src="/_nextassets_/images/tech-installing-device.png" height={640} width={1336} quality={50} alt="Tech installing device" />
          </div>

          <h2 className="h3 marginBottom-small">Vetted pros at your service</h2>
          <p className="p1 marginBottom-large">
            Less than 1 out of every 5 applicants are selected to join the HelloTech platform. During our rigorous onboarding process, techs are hand
            selected, thoroughly background checked and must demonstrate top tier technical knowledge through a series of skills assessments. Our
            continued investment in the best onboarding tools, training, and staff is how we can assure that our nationwide force of techs are the
            best in the business.
          </p>
        </LazyComponent>
      </div>
    </Grid.Fluid>

    <LazyComponent minHeight="300px">
      <PlanGuaranteeBlockDynamic
        title={GUARANTEE_TEXTS.title}
        text="We're committed to your complete satisfaction with our service. If you're not 100% happy, we'll do whatever it takes to make it right."
        classes="marginBottom-large"
      />

      <Grid.Fluid>
        <div className={styles.bodyContainer}>
          <p className="p1 marginBottom-large">
            Our satisfaction guarantee applies to all HelloTech services. If any issues arise during or after your service, please let us know right
            away. We are committed to doing everything we possibly can to make sure that every service we provide ends with a happy customer.
          </p>
        </div>
      </Grid.Fluid>
    </LazyComponent>
  </>
);

export default SafetyAndSupportPage;
